export * from './src/ping-notifications-v1-public-notification-notifications.universal.js';
